import type {
  Styles,
} from '@vtaits/react-paginator';

import type {
  PaginatorPayload,
} from '../types';

import { breakStyle } from './break';
import { pageLinkStyle } from './pageLink';
import { pagesStyle } from './pages';
import { pageLinkGroupStyle } from './pageLinkGroup';

export const styles: Styles<PaginatorPayload> = {
  break: breakStyle,
  pageLink: pageLinkStyle,
  pages: pagesStyle,
  pageLinkGroup: pageLinkGroupStyle,
};
